import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { IPaginateRequest } from 'interfaces/paginate-duck';
import { requestErrorHandler } from 'utils';
import { PaginateCarrierAreaContactsActions } from 'store/ducks/settings/carrier-area-contact';

export function* paginateCarrierAreaContactsRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/carrier/contacts?${queryString}`
    );

    const { contacts, pagination } = responseBody;
    yield put(PaginateCarrierAreaContactsActions.success(contacts, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(PaginateCarrierAreaContactsActions.failure(errorMessage));
  }
}
